import vueI18n from '@/i18n/locale'

const IntelligentIndex = () =>
  import(/* webpackChunkName: 'operateIntelligentIndex' */ '@/pages/intelligent/pages/index.vue')
const IntelligentDetail = () =>
  import(
    /* webpackChunkName: 'operateIntelligentDetail' */ '@/pages/intelligent/pages/detail/index.vue'
  )
const routes = [
  {
    path: '/intelligent',
    name: 'Intelligent',
    redirect: '/intelligent/detail',
    component: IntelligentIndex,
    children: [
      {
        path: 'detail',
        name: 'IntelligentDetail',
        component: IntelligentDetail,
        meta: {
          title: vueI18n.t('FoodB_APP_PxtZ_SCXD' /* 智能营销投资额管理 */),
        },
      },
    ],
  },
]

export default routes
